<template>
    <div id="home-page" :class="!isAccountConfigured && 'bg-dark'">
        <div class="app-container mt-5 mb-5" v-if="!$global.loading">
            <div class="page-title mb-3">
                <span v-if="!isAccountConfigured" class="breadcrumb-link text-white">
                    Avant de commencer...</span>
                <span v-else class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">home</v-icon> Accueil
                </span>

            </div>

            <div v-if="dayLeftSub !== null && dayLeftSub > 0 && dayLeftSub <= 10">
                <v-alert type="error" text class="mt-5 mb-5 form-container mr-auto ml-auto" border="right"
                         colored-border>
                    <p>
                        Votre abonnement à Uska prendra fin dans <b>{{ dayLeftSub }}</b> jours.
                        <router-link to="/configuration/contracts">Mes contrats</router-link>
                    </p>
                </v-alert>
            </div>

            <div v-if="dayLeftSub < 0">
                <v-alert type="error" text class="mt-5 mb-5 form-container mr-auto ml-auto" border="right"
                         colored-border>
                    <p>
                        Votre abonnement à Uska est terminé.
                        <router-link to="/configuration/contracts">Mes contrats</router-link>
                    </p>
                </v-alert>
            </div>

            <div v-if="!isAccountConfigured" id="no-account">
                <div class="row">
                    <div class="col">
                        <div class="p-3 init-action d-flex flex-column align-items-center text-center"
                             @click="redirectOnboard(1)">
                            <div class="title-card">
                                <div class="mb-5 d-flex justify-content-center">
                                    <v-icon v-if="config.organism !== null" color="success" x-large>check
                                    </v-icon>
                                    <v-icon v-else color="error" x-large>clear</v-icon>
                                </div>
                                <h4 class="text-center">Ajouter le nom de ma
                                    structure</h4>
                            </div>
                            <div v-if="config.organism !== null">
                                {{ config.organism.value }}
                            </div>
                            <div v-else class="text-danger">
                                Non configuré
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-3 init-action d-flex flex-column align-items-center text-center"
                             @click="redirectOnboard(1)">
                            <div class="title-card">
                                <div class="mb-5 d-flex justify-content-center">
                                    <v-icon v-if="config.cgu !== null" color="success" x-large>check</v-icon>
                                    <v-icon v-else color="error" x-large>clear</v-icon>
                                </div>
                                <h4 class="blue-grey--text text--darken-1 text-center">Ajouter mes CGU</h4>
                            </div>
                            <div v-if="config.cgu !== null">
                                <a :href="config.cgu.doc_url" target="_blank" class="config-link">
                                    Voir mes CGU
                                </a>
                            </div>
                            <div v-else class="text-danger">
                                Non configuré
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-3 init-action d-flex flex-column align-items-center text-center"
                             @click="redirectOnboard(1)">
                            <div class="title-card">
                                <div class="mb-5 d-flex justify-content-center">
                                    <v-icon v-if="config.logo !== null" color="success" x-large>check</v-icon>
                                    <v-icon v-else color="error" x-large>clear</v-icon>
                                </div>
                                <h4 class="blue-grey--text text--darken-1 text-center">Ajouter mon logo</h4>
                            </div>
                            <div v-if="config.logo !== null">
                                <a :href="config.logo.doc_url" target="_blank" class="config-link">
                                    Voir mon logo
                                </a>
                            </div>
                            <div v-else class="text-danger">
                                Non configuré
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-3 init-action d-flex flex-column align-items-center text-center"
                             @click="redirectOnboard(3)">
                            <div class="title-card">
                                <div class="mb-5 d-flex justify-content-center">
                                    <v-icon v-if="config.oneSender" color="success" x-large>check</v-icon>
                                    <v-icon v-else color="error" x-large>clear</v-icon>
                                </div>
                                <h4 class="blue-grey--text text--darken-1 text-center">Valider au moins une
                                    boîte
                                    d'envoi</h4>
                            </div>
                            <div v-if="config.oneSender">
                                <div v-for="sender in config.senders">
                                    <span v-if="sender.delivery === 'SUCCESS'">
                                        {{ sender.emailable.email }}
                                    </span>
                                </div>
                            </div>
                            <div v-else class="text-danger">
                                Non configuré
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="row">
                <div class="col-12 col-md-6" v-if="isCMAJAvailable">
                    <v-card>
                        <v-card-title>Informations à valider <span class="badge bg-primary text-white mx-2"
                                                                   v-if="filteredAnswers.length">{{
                                filteredAnswers.length
                            }}</span>

                            <v-menu
                              v-if="answers.length"
                              v-model="provenanceMenu"
                              :close-on-content-click="false"
                              offset-y
                              left
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" class="ml-auto">
                                        <v-icon :color="selectedProvenances.length ? 'primary' : ''">filter_list</v-icon>
                                    </v-btn>
                                </template>

                                <v-card class="pa-3" width="280">
                                    <v-select
                                      label="Provenance"
                                      v-model="selectedProvenances"
                                      :items="provenanceOptions"
                                      multiple
                                      chips
                                      deletable-chips
                                      small-chips
                                      clearable
                                      outlined
                                      autofocus
                                    ></v-select>
                                </v-card>
                            </v-menu>
                        </v-card-title>

                        <v-simple-table fixed-header class="simple-table" height="540" v-if="filteredAnswers.length">
                            <thead>
                            <tr>
                                <th class="text-left">Nom</th>
                                <th class="text-left">Provenance</th>
                                <th class="text-left">Reçu le</th>
                                <th class="text-left"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="answer in filteredAnswers">
                                <td>
                                    <router-link :to="'/summary/' + encodeUri(answer.web_form.provider_id)">
                                        {{ answer.provider_data_versions[0].name }}
                                    </router-link>
                                </td>
                                <td>
                                    {{ getProvenance(answer) }}
                                </td>
                                <td>{{ formatDate(answer.updated_at) }}</td>
                                <td>
                                    <router-link :to="answerUrl + answer.web_form.token">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon color="primary" v-bind="attrs" v-on="on">remove_red_eye
                                                </v-icon>
                                            </template>
                                            <span>Voir la réponse</span>
                                        </v-tooltip>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                        <div v-else class="d-flex justify-content-center align-items-center no-items">
                            <small>Aucune donnée</small>
                        </div>
                    </v-card>
                </div>

                <div class="col-12 col-md-6" v-if="isCMAJAvailable">
                    <v-card>
                        <v-card-title>Demandes individuelles en attente de réponse
                            <span class="badge bg-primary text-white mx-2" v-if="filteredWaitingAnswer.length">{{
                                    filteredWaitingAnswer.length
                                }}</span>

                            <v-menu
                              v-if="waitingAnswer.length"
                              v-model="searchMenu"
                              :close-on-content-click="false"
                              offset-y
                              left
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" class="ml-auto">
                                        <v-icon :color="searchName ? 'primary' : ''">filter_list</v-icon>
                                    </v-btn>
                                </template>

                                <v-card class="pa-3" width="280">
                                    <v-text-field
                                      v-model="searchName"
                                      placeholder="Nom du prestataire..."
                                      prepend-inner-icon="search"
                                      clearable
                                      outlined
                                      autofocus
                                    ></v-text-field>
                                </v-card>
                            </v-menu>
                        </v-card-title>

                        <v-simple-table fixed-header class="simple-table" height="540" v-if="filteredWaitingAnswer.length">
                            <thead>
                            <tr>
                                <th class="text-left">Nom</th>
                                <th class="text-left">Envoyé le</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="webForm in filteredWaitingAnswer">
                                <td>
                                    <router-link :to="'/summary/' + encodeUri(webForm.provider_id)">
                                        {{ webForm.last_version.name }}
                                    </router-link>
                                </td>
                                <td>{{ formatDate(webForm.last_web_form.created_at) }}</td>
                                <td>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon
                                                   @click="archiveWebForm(webForm.last_web_form.id)">
                                                <v-icon color="error">clear</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Supprimer la demande</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                        <div v-else class="d-flex justify-content-center align-items-center no-items">
                            <small>Aucune donnée</small>
                        </div>
                    </v-card>
                </div>
                <div :class="account.tis_type.code === 'DAHUB_QUEBEC' ? 'col-12 col-md-8' : 'col'">
                    <v-card>
                        <v-card-title>Historique de vos dernières actions</v-card-title>

                        <v-simple-table fixed-header class="simple-table" height="540" v-if="actions.length">
                            <thead>
                            <tr>
                                <th class="text-left">Type</th>
                                <th class="text-left">Nom fiche</th>
                                <th class="text-left">Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="action in actions">
                                <td>{{ action.type.label }}</td>
                                <td>
                                    <router-link :to="'/summary/' + encodeUri(action.provider.id)"
                                                 v-if="action.provider_data.name !== null">
                                        {{ action.provider_data.name }}
                                    </router-link>
                                    <span v-else>{{ action.provider.last_version.name }}</span>
                                </td>
                                <td>{{ formatDate(action.created_at) }}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                        <div v-else class="d-flex justify-content-center align-items-center no-items">
                            <small>Aucune donnée</small>
                        </div>
                    </v-card>
                </div>

                <div class="col-12 col-md-4" v-if="account.tis_type.code === 'DAHUB_QUEBEC'">
                    <v-card>
                        <v-card-title>Brouillons en cours <span class="badge bg-primary text-white mx-2"
                                                                v-if="drafts.length">{{
                                drafts.length
                            }}</span></v-card-title>
                        <v-simple-table fixed-header class="simple-table" height="540" v-if="drafts.length">
                            <tr v-for="draft in drafts">
                                <td width="80%">
                                    <router-link :to="'/summary/' + encodeUri(draft.provider.id)">
                                        {{ draft.provider.name }}
                                    </router-link>
                                </td>
                                <td width="20%">
                                    <v-btn @click="checkDraft(draft)" class="custom-button-primary border-0" outlined>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon color="primary" v-bind="attrs" v-on="on">edit
                                                </v-icon>
                                            </template>
                                            <span>Continuer l'édition</span>
                                        </v-tooltip>
                                    </v-btn>
                                </td>
                            </tr>
                        </v-simple-table>

                        <div v-else class="d-flex justify-content-center align-items-center no-items">
                            <small>Aucune donnée</small>
                        </div>
                    </v-card>
                </div>
            </div>

        </div>

        <confirm ref="confirm"></confirm>

        <v-dialog v-model="takeDraftModal" width="700px" v-if="selectedDraft !== null" persistent>
            <take-power-back-modal :draft="selectedDraft"></take-power-back-modal>
        </v-dialog>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import Confirm from "@/components/tools/Confirm"
import TakePowerBackModal from "./tools/TakePowerBackModal.vue"

export default {
    name: "HomePage",
    components: {Confirm, TakePowerBackModal},
    data() {
        return {
            config: {},
            subscription: null,
            dayLeftSub: null,
            waitingAnswer: [],
            answers: [],
            actions: [],
            drafts: [],
            answerUrl: 'answer/',
            takeDraftModal: false,
            selectedDraft: null,
            noMoreDraftModal : false,
            selectedProvenances: [],
            provenanceOptions: ['Professionnel', 'Campagne', 'Demande individuelle'],
            searchName: '',
            searchMenu: false,
            provenanceMenu: false,
        }
    },
    methods: {
        ...mapMutations('providerFilter', [
            'pushWebFormState'
        ]),
        redirectOnboard(step) {
            this.$router.push({path: '/onboard', query: {step: step}})
        },
        getStats() {
            this.$global.loading = true

            this.$http.get('auth/user/home-stats').then(res => {
                this.waitingAnswer = res.body.data.waitingAnswer
                this.answers = res.body.data.answers
                this.actions = res.body.data.actions
                this.drafts = res.body.data.drafts

                this.$global.loading = false
            })
        },
        encodeUri(id) {
            return btoa(id)
        },
        archiveWebForm(id) {
            this.$refs.confirm.open('Attention',
                'Êtes-vous sûr de vouloir supprimer la demande ?',
                {color: 'red'}).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    this.$http.get('auth/webform/archive/' + id).then(res => {
                        this.getStats()
                    })
                }
            })
        },
        checkDraft(draft) {
            this.$http.get("sitform/check-draft/" + draft.provider.id).then(res => {
                if(res.body.success) {
                    this.noMoreDraftModal = true
                } else {
                    let webForm = res.body.data.webForm
                    if(webForm.user.id === this.user.id) {
                        this.continueDraft(draft)
                    } else {
                        this.selectedDraft = {
                            user_name: webForm.user.last_name,
                            user_first_name: webForm.user.first_name,
                            user_id: webForm.user.id,
                            drafted_at: webForm.answer.drafted_at,
                            provider_data_id: webForm.answer.provider_data_versions[0].id,
                            web_form_id: webForm.id,
                            provider_id: draft.provider.id,
                            aspect: webForm.answer.provider_data_versions[0].aspect,
                        }

                        this.takeDraftModal = true
                    }
                }
            })
        },
        continueDraft(draft) {
            this.$router.push({path: '/sit/formulaire/' + draft.provider.id,
                query: {
                    providerDataId: draft.draft.provider_data_id,
                    newDraft: false,
                    aspect: draft.draft.aspect,
                }})
        },
        getProvenance(answer) {
            if (answer.web_form.open_form) return 'Professionnel';
            if (answer.web_form.cmaj_batch_id !== null) return 'Campagne';
            return 'Demande individuelle';
        },
    },
    computed: {
        ...mapState('account', ['account', 'user',]),
        isAccountConfigured() {
            return this.config.cgu !== null &&
                this.config.logo !== null &&
                this.config.organism !== null &&
                this.config.oneSender
        },
        isCMAJAvailable() {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {
                contracts.forEach(contract => {
                    let module = contract.contract_offer.options.filter(option => option.code === 'CMAJ')

                    if (module.length) {
                        available = true
                    }
                })
            }

            return available
        },
        filteredAnswers() {
            if (!this.selectedProvenances.length) {
                return this.answers;
            }
            return this.answers.filter(answer =>
              this.selectedProvenances.includes(this.getProvenance(answer))
            );
        },
        filteredWaitingAnswer() {
            if (!this.searchName) {
                return this.waitingAnswer;
            }
            const search = this.searchName.toLowerCase();
            return this.waitingAnswer.filter(webForm =>
              webForm.last_version.name.toLowerCase().includes(search)
            );
        },
    },
    created() {
        this.config = this.account.configurations

        if (this.account.current_contracts.length) {
            this.subscription = this.account.account_contracts.filter(contract => {
                return contract.contract_offer.code !== 'USKA_FREEMIUM'
                    && contract.contract_offer.code !== "ADHESION_INVOICE"
            })

            if (this.subscription !== undefined) {
                this.subscription.sort((a, b) => new Date(b.valid_through) - new Date(a.valid_through))
                let endSub = this.$moment(this.subscription[0].valid_through)
                let now = this.$moment()

                this.dayLeftSub = endSub.diff(now, 'days')
            }
        }

        if(this.account.tis_type.code === 'DAHUB_QUEBEC') {
            this.answerUrl = 'sit-answer/'
        }

        this.getStats()

        this.$global.$on("close_take_power_back_modal", () => {
            this.takeDraftModal = false
        })
    }
}
</script>